
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

// TODO: Be more smart with added and removed events

/**
 * Keeps track of the contact list, and the contacts' data
 * @type {Model}
 */
module.exports = Model({
	name: "managedcontacts",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	_who_tracker: null,
	_group: null,
	_contacts: null, // The array of contact ids
	_people: null,

	refresh: refresh,
	recalculate: recalculate,
	reset: reset,
	track_contacts: track_contacts,
	track_people: track_people,
	sayViewing: sayViewing,
});

function init() {
	this._contacts = [];
	this._people = {};
	this._who = null;
	this._who_tracker = this.dispatcher.createTracker();
	this._group = null;

	this.push([]);
}

/**
 * Removes all listeners from the dispatcher and the people store
 * @return {Promise} Resolves after everything is done.
 */
function uninit() {
	this._contacts = null;
	this._group = null;
	this._who = null;
	this._who_tracker.off(); //Ensures all trackers off off to ensure 'clean' start.
	this._who_tracker = null;
}

/**
 * Adds listeners for changes in the ManagedAccount model, People model, and
 * connectivity (an event)
 */
function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": handle_people_update,
	};
}

/**
 * Listens for a request from the UI to remove a contact.
 * @return {[type]} [description]
 */
function triggers() {
	return {
		"remove": remove,
		"view": view, // Load models related to the page and notify that the page should be opened
		"load": load, // Just load the contacts and don't view the page
		"reset": trigger_reset,
	};
}

function view(data) {
	var who = data.who;

	if(who === this._who) {
		this.sayViewing();
		return;
	}

	const group = data.group;

	this._who = who;
	this._group = group;

	this.refresh().then(sayViewing.bind(this));
	this.track_contacts();

	this.emit("managedcontactrequests:trigger:view", data);
	this.emit("managedaccountinvites:trigger:view", data);

	this.emit("usermetrics:trigger:track", "open managed user's contacts", {
		who: this._who,
	});
}

function load(data) {
	var who = data.who;

	if(who === this._who)
		return;

	const group = data.group;

	this._who = who;
	this._group = group;

	this.refresh();
	this.track_contacts();
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who,
		group: this._group
	});
}

function trigger_reset() {
	this.reset();
	this.emit("managedcontactrequests:trigger:clear");
}

/**
 * Sets trackers to monitor changes in the 'managee' contacts list.
 */
function track_contacts() {
	var managee = this._who;
	var group = this._group;
	var tracker = this._who_tracker;
	tracker.off(); //Ensures all trackers off to ensure 'clean' start.
	if(group){
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/contacts/added", on_added.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/contacts/removed", on_removed.bind(this));
	} else {
		tracker.on("mqtt:u/" + managee + "/contacts/added", on_added.bind(this));
		tracker.on("mqtt:u/" + managee + "/contacts/removed", on_removed.bind(this));
	}
}

function on_added(data) {
	var user = data.user;

	this._contacts = this._contacts.concat(user);

	this.track_people([user]);

	this.recalculate();

	this.dispatch("newcontact", {
		who: this._who,
		section: "contacts",
		timestamp: new Date().toISOString(),
	});
}

function on_removed(data) {
	var user = data.user;

	this._contacts = this._contacts.filter(function (existing) {
		return existing !== user;
	});

	this.recalculate();

	this.dispatch("newcontact", {
		who: this._who,
		section: "contacts",
		timestamp: new Date().toISOString(),
	});
}

/**
 * Takes a string with a Person _id and makes a call to the api to remove
 * the Person from the contact list of the 'Managee'
 * @return {[type]} [description]
 */
function remove(data) {
	var who = data.who; //who is being removed
	var managee = this._who; //_id of the managee
	if (!managee) return;

	const group = this._group;

	this.emit("save:trigger:start");

	this.emit("usermetrics:trigger:track", "remove managed user's contact", {
		who: managee,
		contact: who
	});

	return this.api.manage.contacts.remove(who, managee, group)
		.catch(console.error.bind(console))
		.then(remove_finished.bind(this));
}

function remove_finished() {
	this.dispatch("newcontact", {
		who: this._who,
		section: "contacts",
		timestamp: new Date().toISOString(),
	});
	this.emit("save:trigger:finish");
}


/**
 * Resets the trackers (turns them off), clears the model's data, and
 * sets the managee to 'null' ie. returns model to init() state.
 */
function reset() {
	this._who_tracker.off();
	this.push([]);
	this._who = null;
	this._group = null;
}

function handle_people_update(people) {
	this._people = people;
	this.recalculate();
	this.dispatch("newcontact", {
		who: this._who,
		section: "contacts",
		timestamp: new Date().toISOString(),
	});
}

/**
 * Processes the map of all people and returns an array of just the contacts' data
 * @return {Array}        Array of all contacts' data
 */
function recalculate() {
	var people = this._people;
	return this.push(this._contacts.reduce(function (list, id) {
		var person = people[id];
		if (person) list.push(person);
		return list;
	}, []));
}

/**
 * Refreshes the contact list and adds all contacts to be watched by the people store
 * @return {Promise} Resolves when everything is refreshed and passed to people store
 */
function refresh() {
	var managee = this._who;
	if (!managee) return;

	const group = this._group;

	this.emit("save:trigger:start");
	return this.api.manage.contacts.list(managee, group) // Get the contacts list
		.then(set_contacts.bind(this)) // Set _contacts on the store
		.then(track_people.bind(this)) // Add all contacts to people store
		.then(recalculate.bind(this)) // Recalculate the current list
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}


/**
 * Emits a message to track the contacts added to the 'people' store.
 * @param  {[type]} contacts [description]
 * @return {[type]}          [description]
 */
function track_people(contacts) {
	this.emit("people:trigger:add", {
		lean: true,
		who: contacts
	});
}

/**
 * Really kinda self-explanatory
 */
function set_contacts(contacts) {
	this._contacts = contacts;
	return contacts;
}
